import React, { useState } from "react";

const colors = [
  "#e50914", "#2196f3", "#4caf50", "#ff9800", "#9c27b0",
  "#00bcd4", "#ff5722", "#795548", "#607d8b", "#3f51b5",
];

function getColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
}

function getInitials(name) {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

const CastCard = ({ member, movie }) => {
  const color = getColor(member.name);
  const initials = getInitials(member.name);
  const [imgFailed, setImgFailed] = useState(false);
  const hasPhoto = !!member.profileUrl && !imgFailed;

  return (
    <div className="cast-card">
      <div className="cast-card-inner">
        <div
          className="cast-card-front"
          style={!hasPhoto ? { background: color } : undefined}
        >
          {hasPhoto && (
            <img
              src={member.profileUrl}
              alt={member.name}
              className="cast-photo"
              onError={() => setImgFailed(true)}
            />
          )}
          {hasPhoto ? (
            <div className="cast-front-overlay">
              <h3 className="cast-name">{member.name}</h3>
              {member.character && (
                <p className="cast-character">as {member.character}</p>
              )}
            </div>
          ) : (
            <>
              <div className="cast-avatar">{initials}</div>
              <h3 className="cast-name">{member.name}</h3>
              {member.character && (
                <p className="cast-character">as {member.character}</p>
              )}
            </>
          )}
        </div>
        <div className="cast-card-back">
          <h3>{member.name}</h3>
          {member.character && (
            <p className="mb-2">
              <em>as {member.character}</em>
            </p>
          )}
          <hr style={{ borderColor: "rgba(255,255,255,0.3)" }} />
          <p>
            <strong>Appears in:</strong>
          </p>
          <p>
            {movie.Title} ({movie.Year})
          </p>
          <div className="mt-2">
            {member.wikiUrl && (
              <a
                href={member.wikiUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-outline-light mr-2"
              >
                <i className="fab fa-wikipedia-w mr-1"></i> Wiki
              </a>
            )}
            <a
              href={`https://www.imdb.com/find?q=${encodeURIComponent(member.name)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-sm btn-outline-light"
            >
              <i className="fab fa-imdb mr-1"></i> IMDB
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CastCard;
